import { render } from "./LogoGoOrangeIcon.vue?vue&type=template&id=72bb7c0c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/LogoGoOrangeIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72bb7c0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72bb7c0c', __exports__)) {
    api.reload('72bb7c0c', __exports__)
  }
  
  module.hot.accept("./LogoGoOrangeIcon.vue?vue&type=template&id=72bb7c0c", () => {
    api.rerender('72bb7c0c', render)
  })

}


export default __exports__